import {useQuery} from "@tanstack/react-query";
import {request, gql} from "graphql-request";

export const GET_ALL_DETAILS_QUERY = gql`
  query Get_all_plan_types {
    get_all_plan_types {
      plan_id
      drb_plan_type_name
      plan_type_name
      slot_number
      amount
      description
      item_type
      enabled
      style
      order
    }
  }
`;

interface Plan {
	plan_id: string;
	drb_plan_type_name: string;
	plan_type_name: string;
	slot_number: number;
	amount: string;
	description: string;
	item_type: string;
	enabled: boolean;
	order: number;
	style: string;
}

interface GetAllDetailsResponse {
	get_all_plan_types: Plan[];
}

export const useGetAllDetailsQuery = (brand: any) => {
	const endpoint = (
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_GRAPHQL_API_URL_CLEANFREAK
			: process.env.REACT_APP_GRAPHQL_API_URL_RAINSTORM
	) as string;

	return useQuery<GetAllDetailsResponse>({
		queryKey: ["getAllDetails", brand],
		queryFn: async (): Promise<GetAllDetailsResponse> => {
			const data = await request(endpoint, GET_ALL_DETAILS_QUERY);
			return data as GetAllDetailsResponse;
		},
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};
